// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ghYs","top":"styles_top__1sAOL","left":"styles_left__2Gcgd","description":"styles_description__5UOgV"};